<template>
<div
      class="comfy-select"
      tabindex="0"
      @click.self="isActive=!isActive"
      @focusout="isActive=false"
      :class="{pending: value.some( v=> {return v.toAdd})}"
>
  <div
        class="always-visible"
        @click="isActive=!isActive"
  >
    <div
          class="select__select"
          :class="{select__active: isActive}"
    ></div>
    <!-- @click="isActive=!isActive" -->

    <!-- <div class="label">
      {{label}}
    </div> -->
    <!-- <div
          class="select__tags-wrap"
          v-for="(obj,id) in value"
          :key="id"
    > -->
    <span
          v-for="(obj,id) in value"
          :key="id"
          v-if="obj.isPresent==true && obj.toRemove==false || obj.toAdd==true"
          class="select__tag"
          v-on:click.stop
          :style="StylesForEventSelect(obj.name, obj.isPresent, obj.toRemove, obj.toAdd)"
    >
      {{obj.name}}
      <i
            aria-hidden="true"
            tabindex="1"
            class="select__tag-icon"
            @click="ontoggle(id)"
            :class="{removing: obj.toRemove}"
      ></i>
    </span>
    <!-- </div> -->
  </div>

  <div
        class="select__content-wrap"
        :class="{display: isActive}"
  >
    <ul class="select__content">
      <div class="line-break">

      </div>
      <li
            class="select__element"
            v-for="(obj,id) in value"
            :key="id"
            :style="StylesForEventSelect(obj.name, obj.isPresent, obj.toRemove, obj.toAdd)"
            @click="ontoggle(id)"
      >

        <!-- :class="{isPresent: obj.isPresent, removing: obj.toRemove, adding: obj.toAdd}" -->
        <span>{{obj.name}}</span>
        <i class="fas fa-question">
          <div class="tooltip">
            <div class="tooltiptext">{{obj.tip}}</div>
          </div>
        </i>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import HelpersRes from '@/helpers/Helpers.js';
export default {
  props: {
    label: {
      type: String,
      default: "",
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
      required: true,
    },
    ontoggle: {
      type: Function,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    // byIsPresent(a, b) {
    //   return (a.isPresent === b.isPresent) ? 0 : a.isPresent ? -1 : 1;
    // }
    StylesForEventSelect(objName, isPresent, isRemoving, isAdding) {
      if (isRemoving || isAdding) {
        return HelpersRes.StylesForEventSelectRemoving(objName)
      }
      if (isPresent) {
        return HelpersRes.StylesForEventSelectPresent(objName)
      }
      return HelpersRes.StylesForEventSelectRemoving(objName)
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<style lang="scss">
@import '../assets/variables.scss';
.comfy-select {
    width: 357px;
    text-align: left;
    display: block;
    // padding: 2px 20px 0 6px;
    // border-radius: 5px;
    // border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 14px;
    position: relative;
    outline: none;
    box-sizing: border-box;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    /* The emerging W3C standard
       that is currently Firefox-only */
    * {
        scrollbar-width: thin;
        scrollbar-color: blue orange;
    }
    /* Works on Chrome/Edge/Safari */
    *::-webkit-scrollbar {
        width: 8px;
    }
    *::-webkit-scrollbar-track {
        background: transparent;
    }
    *::-webkit-scrollbar-thumb {
        background-color: $textGray;
        border-radius: 50px;
        border: 1px solid white;
    }
    &.pending {
        border-color: $darkBlue;
    }
    .always-visible {
        max-height: 48px;
        // overflow-x: scroll;
        margin-right: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        &:hover {
            cursor: pointer;
        }
    }
    .select__select {
        box-sizing: border-box;
        position: absolute;
        width: 20px;
        height: 20px;
        right: 1px;
        top: 1px;
        padding-top: 4px;
        padding-bottom: 6px;
        margin-right: 5px;
        text-align: center;
        -webkit-transition: -webkit-transform 0.2s ease;
        transition: -webkit-transform 0.2s ease;
        transition: transform 0.2s ease;
        transition: transform 0.2s ease, -webkit-transform 0.2s ease;
        &:hover {
            cursor: pointer;
        }
        &.select__active {
            transform: rotate(180deg);
        }
    }
    .label {
        display: inline;
        position: relative;
        display: inline-block;
        padding: 4px;
        margin-right: 5px;
        font-weight: bold;
        line-height: 1;
        // margin-bottom: 5px;
        white-space: nowrap;
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
    }
    .select__select:before {
        position: relative;
        right: 0;
        top: 65%;
        color: #999;
        height: 10px;
        margin-top: 4px;
        border-color: #999 transparent transparent;
        border-style: solid;
        border-width: 5px 5px 0;
        content: "";
    }
    // .select__tags-wrap {
    .select__tag {
        display: inline;
        position: relative;
        display: inline-block;
        padding: 4px 16px 4px 10px;
        border-radius: 5px;
        color: #fff;
        line-height: 1;
        box-sizing: border-box;
        border: 1px solid;
        white-space: nowrap;
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;

        &.removing {
            background-color: white !important;
        }
        &.adding {
            background-color: $darkBlue;
            // color: black;
        }

        .select__tag-icon {
            cursor: pointer;
            margin-left: 2px;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            font-weight: 700;
            font-style: normal;
            width: 15px;
            text-align: center;
            line-height: 22px;
            -webkit-transition: all 0.2s ease;
            transition: all 0.2s ease;
            border-radius: 5px;

            // filter: brightness(1);
            // &:hover {
            //     filter: brightness(0.1);
            // }
        }
        .select__tag-icon:after {
            content: "\D7";
            color: black;
            font-size: 14px;
        }
        .select__tag-icon {
            &.removing {
                &:after {
                    content: "+";
                }
                &:hover:after {
                    color: black;
                }
            }
        }
        .select__tag-icon:hover:after {
            color: white;
        }
    }
    // }
    *:focus {
        outline: none;
    }
    .select__content-wrap {
        position: absolute;
        display: none;
        background: #fff;
        width: 100%;
        max-height: 340px;
        overflow: auto;
        border: 1px solid #e8e8e8;
        // border-top: none;
        overflow: visible;
        z-index: 1;
        width: 500px;
        right: -30px;
        border-radius: 5px;
        &.display {
            display: block;
        }
        .select__content {
            box-sizing: border-box;
            padding-inline-start: 0;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            // padding: 8px;
            text-align: left;
            margin-left: 7.5%;
            margin-right: 7.5%;
            // min-width: 85%;
            vertical-align: top;
            .line-break {
                width: 100%;
            }
            .divider {
                text-align: left;
                font-weight: bold;
            }
            .select__element {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                min-width: 100px;
                min-height: 25px;
                box-sizing: border-box;
                margin: 3px;
                padding: 3px 6px;
                // border-radius: 5px;
                // border-width: 2px;
                // border-style: solid;
                border: 1px solid;
                border-radius: 5px;

                .fa-question {
                    display: none;
                    margin-top: auto;
                    margin-bottom: auto;
                    font-size: 10px;
                    position: relative;
                    .tooltip {
                        visibility: hidden;
                        width: 120px;
                        min-height: 50px;
                        background-color: #FF7F50;
                        text-align: center;
                        padding: 5px 0;
                        border-radius: 6px;

                        /* Position the tooltip text */
                        position: absolute;
                        z-index: 10;
                        top: -20%;
                        left: 280%;

                        /* Fade in tooltip */
                        opacity: 0;
                        transition: opacity 0.3s;
                        .tooltiptext {
                            position: relative;
                            color: white;
                            font-size: 14px;
                            font-weight: bold;
                            padding: 5px;
                        }
                        &:after {
                            content: "";
                            position: absolute;
                            border-top: 6px solid transparent;
                            border-bottom: 6px solid transparent;
                            border-right: 7px solid #FF7F50;
                            left: -6px;
                            top: 9px;

                        }
                    }

                    &:hover .tooltip {
                        visibility: visible;
                        opacity: 1;
                    }
                }
                &:hover {
                    cursor: pointer;
                    background: darken(white,3%);
                    > .fa-question {
                        display: block;
                    }
                }
                &.isPresent {
                    background-color: $greenSelect;
                    border-color: $green;
                    color: #fff;
                    &:hover {
                        background-color: lighten($greenSelect,8%);
                    }
                    &.removing {
                        background-color: lighten($greenSelect,25%);
                        &:hover {
                            background-color: lighten($greenSelect,8%);
                        }
                    }
                }
                &.adding {
                    background-color: $darkBlue;
                    color: white;
                    &:hover {
                        background-color: lighten($darkBlue,8%);
                    }
                }
            }
        }
    }
}
</style>
